<template>
  <div class="">
    <button 
      v-if="getPreviousLabel() != null"
      v-on:click="goToPrevious" 
      class="text-white focus:outline-none bg-blue-500 hover:bg-blue-600 inline-block overflow-hidden font-semibold text-sm mr-4" style="padding:15px 30px 13px 30px;">
      <div class="float-left">
        {{ getPreviousLabel() }}
      </div>

      <div class="float-left mx-4" style="margin-top:1px;">
        <img src="/static/img/icons/icons8-chevron_left_filled.png" 
          style="width:16px;" />
      </div>

      <div class="float-left">
        Previous
      </div>            
    </button>

    <button 
      v-on:click="goToNext" 
      class="text-white bg-blue-500 hover:bg-blue-600 inline-block overflow-hidden font-semibold text-sm focus:outline-none" style="padding:15px 30px 13px 30px;">
      <div class="float-left">
        Next
      </div>

      <div class="float-left mx-4" style="margin-top:1px;">
        <img src="/static/img/icons/icons8-chevron_right_filled.png" 
          style="width:16px;" />
      </div>

      <div class="float-left">
        {{ getNextLabel() }}
      </div>            
    </button>
  </div>
</template>

<script>
	export default {

    methods : {

      getPrevApplicant() {
        let applicants = this.$store.state[this.$store.state.view + 'Module'].client.applicants

        for(let i=0; i < applicants.length; i++) {
          let applicant = applicants[i]

          if(applicant.id == this.$route.params.applicantId && i-1 >=0) {
            return applicants[i-1]
          }
        }

        return null
      },

      getCurrApplicant() {
        let applicants = this.$store.state[this.$store.state.view + 'Module'].client.applicants

        for(let i=0; i < applicants.length; i++) {
          let applicant = applicants[i]

          if(applicant.id == this.$route.params.applicantId) {
            return applicants[i]
          }
        }

        return null
      },

      getNextApplicant() {
        let applicants = this.$store.state[this.$store.state.view + 'Module'].client.applicants

        for(let i=0; i < applicants.length; i++) {
          let applicant = applicants[i]

          if(applicant.id == this.$route.params.applicantId && i+1 < applicants.length) {
            return applicants[i+1]
          }
        }

        return null
      },


      getPreviousLabel() {
        let name = this.$route.name

        if(name == 'application-applicant-profile') {
          return null
        }

        else if(name == 'application-applicant-address') {
          return 'Profile'
        }

        else if(name == 'application-applicant-employment') {
          return 'Address'
        }

        else if(name == 'application-requirement') {
          let lastApplicant = _.last(this.$store.state[this.$store.state.view + 'Module'].client.applicants)

          if(lastApplicant.person != null) {
            return 'Employment'
          }

          else {
            return this.getApplicantName(lastApplicant) + ' profile' 
          }  
        }

        else if(name == 'application-asset') {
          return 'Requirements'
        }

        else if(name == 'application-liability') {
          return 'Assets'
        }

        else if(name == 'application-expense') {
          return 'Liabilities'
        }

        else if(name == 'application-risk-profile') {
          return 'Living Expenses'
        }

        else if(name.indexOf('document') > -1) {
          let prevApplicant = this.getPrevApplicant()

          if(prevApplicant == null) {
            return 'Risk Profile'
          }

          else {
            return 'Documents for ' + this.getApplicantName(prevApplicant)
          }          
        }
      },



      getNextLabel() {
        let name = this.$route.name

        if(name == 'application-applicant-profile') {
          let currApplicant = this.getCurrApplicant()
          if(currApplicant.person != null) {
            return 'Address'
          } else {
            let nextApplicant = this.getNextApplicant()

            if(nextApplicant == null) {
              return 'Requirements'  
            }

            else {
              return 'Next applicant\'s profile'
            }
          }
        }

        else if(name == 'application-applicant-address') {
          return 'Employment'
        }

        else if(name == 'application-applicant-employment') {
          let nextApplicant = this.getNextApplicant()

          if(nextApplicant == null) {
            return 'Requirements'  
          }

          else {
            return 'Next applicant\'s profile'
          }      
        }

        else if(name == 'application-requirement') {
          if(this.$store.state.view == 'broker' || this.isPageVisible('assets')) {
            return 'Assets'
          }

          else {
            name = 'application-asset'
          }
        }

        if(name == 'application-asset') {
          if(this.$store.state.view == 'broker' || this.isPageVisible('liabilities')) {
            return 'Liabilities'
          }

          else {
            name = 'application-liability'
          }
        }

        if(name == 'application-liability') {
          if(this.$store.state.view == 'broker' || this.isPageVisible('expenses')) {
            return 'Living Expenses'
          }

          else {
            name = 'application-expense'
          }
        }

        if(name == 'application-expense') {
          if(this.$store.state.view == 'broker' || this.isPageVisible('risk-profiles')) {
            return 'Risk Profile'
          }

          else {
            name = 'application-risk-profile'
          }
        }

        if(name == 'application-risk-profile') {
          if(this.$store.state.view == 'broker' || this.isPageVisible('documents')) {
            return 'Documents'
          }

          else {
            return 'Submit'
          }
        }

        else if(name.indexOf('document') > -1) {
          let nextApplicant = this.getNextApplicant()

          if(nextApplicant == null) {
            return 'Submit'
          }

          else {
            return 'Documents for ' + this.getApplicantName(nextApplicant)
          }          
        }
      },

      goToPrevious() {
        let name = this.$route.name

        if(name == 'application-applicant-profile') {
          let prevApplicant = this.getPrevApplicant()

          if(prevApplicant != null) {
            this.$router.push({ 
              name  : 'application-applicant-employment', 
              params: {
                clientId   : this.$route.params.clientId, 
                applicantId: prevApplicant.id
              }
            })
          }
        }

        else if(name == 'application-applicant-address') {
          this.$router.push({ 
            name  : 'application-applicant-profile', 
            params: {
              clientId   : this.$route.params.clientId, 
              applicantId: this.$route.params.applicantId 
            }
          })
        }

        else if(name == 'application-applicant-employment') {
          this.$router.push({ 
            name  : 'application-applicant-address', 
            params: {
              clientId   : this.$route.params.clientId,
              applicantId: this.$route.params.applicantId 
            }
          })
        }

        else if(name == 'application-requirement') {
          let lastApplicant = _.last(this.$store.state[this.$store.state.view + 'Module'].client.applicants)

          if(lastApplicant.person != null) {
            this.$router.push({ 
              name  : 'application-applicant-employment', 
              params: {
                clientId   : this.$route.params.clientId,
                applicantId: lastApplicant.id
              }
            })
          }

          else {
            this.$router.push({
              name : 'application-applicant-profile',
              params : {
                clientId   : this.$route.params.clientId,
                applicantId: lastApplicant.id
              }
            })
          }
        }

        else if(name == 'application-asset') {
          this.$router.push({ 
            name  : 'application-requirement', 
            params: {
              clientId : this.$route.params.clientId 
            }
          })
        }

        else if(name == 'application-liability') {
          this.$router.push({ 
            name  : 'application-asset', 
            params: {
              clientId : this.$route.params.clientId 
            }
          })
        }

        else if(name == 'application-expense') {
          this.$router.push({ 
            name  : 'application-liability', 
            params: {
              clientId : this.$route.params.clientId 
            }
          })
        }

        else if(name == 'application-risk-profile') {
          this.$router.push({ 
            name  : 'application-expense', 
            params: {
              clientId: this.$route.params.clientId, 
            }
          })
        }

        else if(name.indexOf('document') > -1) {
          let prevApplicant = this.getPrevApplicant()

          if(prevApplicant != null) {
            this.$router.push({ 
              name  : 'application-document', 
              params: {
                clientId   : this.$route.params.clientId, 
                applicantId: prevApplicant.id
              }
            })
          }

          else {
            this.$router.push({ 
              name  : 'application-risk-profile', 
              params: {
                clientId: this.$route.params.clientId, 
              }
            })
          }
        }
      },


      goToNext() {
        let name = this.$route.name

        if(name == 'application-applicant-profile') {
          
          let currApplicant = this.getCurrApplicant()
          
          if(currApplicant.person != null) {
            this.$router.push({ 
              name  : 'application-applicant-address', 
              params: {
                clientId   : this.$route.params.clientId, 
                applicantId: this.$route.params.applicantId 
              }
            })
          } 

          else {
            let nextApplicant = this.getNextApplicant()

            if(nextApplicant == null) {
              this.$router.push({ 
                name  : 'application-requirement', 
                params: {
                  clientId : this.$route.params.clientId 
                }
              })
            }

            else {
              this.$router.push({ 
                name  : 'application-applicant-profile', 
                params: {
                  clientId   : this.$route.params.clientId, 
                  applicantId: nextApplicant.id 
                }
              })
            }
          }

          
        }

        else if(name == 'application-applicant-address') {
          this.$router.push({ 
            name  : 'application-applicant-employment', 
            params: {
              clientId   : this.$route.params.clientId, 
              applicantId: this.$route.params.applicantId 
            }
          })
        }

        else if(name == 'application-applicant-employment') {
          let nextApplicant = this.getNextApplicant()

          if(nextApplicant == null) {
            this.$router.push({ 
              name  : 'application-requirement', 
              params: {
                clientId : this.$route.params.clientId 
              }
            })
          }

          else {
            this.$router.push({ 
              name  : 'application-applicant-profile', 
              params: {
                clientId   : this.$route.params.clientId, 
                applicantId: nextApplicant.id 
              }
            })
          }          
        }

        else if(name == 'application-requirement') {
          if(this.$store.state.view == 'broker' || this.isPageVisible('assets')) {
            this.$router.push({ 
              name  : 'application-asset', 
              params: {
                clientId : this.$route.params.clientId 
              }
            })
          }

          else {
            name = 'application-asset'
          }
        }

        if(name == 'application-asset') {
          if(this.$store.state.view == 'broker' || this.isPageVisible('liabilities')) {
            this.$router.push({ 
              name  : 'application-liability', 
              params: {
                clientId : this.$route.params.clientId 
              }
            })
          }

          else {
            name = 'application-liability'
          }
        }

        if(name == 'application-liability') {
          if(this.$store.state.view == 'broker' || this.isPageVisible('expenses')) {
            this.$router.push({ 
              name  : 'application-expense', 
              params: {
                clientId : this.$route.params.clientId 
              }
            })
          }

          else {
            name = 'application-expense'
          }
        }

        if(name == 'application-expense') {
          if(this.$store.state.view == 'broker' || this.isPageVisible('risk-profiles')) {
            this.$router.push({ 
              name  : 'application-risk-profile', 
              params: {
                clientId : this.$route.params.clientId 
              }
            })
          }

          else {
            name = 'application-risk-profile'
          }
        }        

        if(name == 'application-risk-profile') {
          if(this.$store.state.view == 'broker' || this.isPageVisible('documents')) {
            this.$router.push({ 
              name  : 'application-document', 
              params: {
                clientId   : this.$route.params.clientId, 
                applicantId: this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].id 
              }
            })
          }

          else {
            this.$router.push({ 
              name  : 'application-submit-client', 
              params: {
                clientId : this.$route.params.clientId 
              }
            })
          }
        }

        else if(name.indexOf('document') > -1) {
          let nextApplicant = this.getNextApplicant()

          if(nextApplicant == null) {
            this.$router.push({ 
              name  : this.$store.state.view == 'broker' ? 'application-submit-broker' : 'application-submit-client', 
              params: {
                clientId : this.$route.params.clientId 
              }
            })
          } 

          else {
            this.$router.push({ 
              name  : 'application-document',
              params: {
                clientId   : this.$route.params.clientId, 
                applicantId: nextApplicant.id
              }
            })
          }
        }
      }
    }
	}
</script>